import { CreateSerializer, plainToClass } from '@ftr/serialization';
import { AudioChunk, MultiTrackAudioChunk } from '../../type/recording';
export const AUDIO_OBJECT_SERIALIZER_IDENTIFIER = Symbol('audioObjectSerializer');
/**
 * Serializer for an AudioObject property
 * Serialized format is a plain string
 */
export const audioObjectSerializer = CreateSerializer(undefined, deserializeAudio);
function deserializeAudio(value) {
    if ('tracks' in value) {
        return plainToClass(MultiTrackAudioChunk, value);
    }
    return plainToClass(AudioChunk, value);
}
